import { CardsFeedbackType, TimeFrames } from './types'

export const ALL_TIMEFRAME_OPTIONS: TimeFrames[] = [
	'Last 24 Hours',
	'Last 7 Days',
	'Last 14 Days',
	'Last 30 Days',
	'Last 3 Months',
	'Last 6 Months',
	'Last 12 Months',
]

export const ALL_CARD_FEEDBACK_TYPE_OPTIONS: CardsFeedbackType[] = [
	'All',
	'Complaints',
	'Commendations',
]
